import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  reason: Yup.string(),
});

export { validationSchema };
